import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import OutcomeScene from "../components/OutcomeScene.jsx";
import BusinessExamples from "../components/BusinessExamples.jsx";
import Reveal from "../components/Reveal.jsx";
import {
  OrganizationReferences,
  ProductSpotlights,
  ClientTestimonials,
  LatestNews,
} from "../components/LegacySections.jsx";
import ProductReach from "../components/ProductReach.jsx";
import BrochureDownload from "../components/BrochureDownload.jsx";
import DiscoverySection from "../components/DiscoverySection.jsx";

export default function Home() {
  return (
    <main id="main" className="kw-home-simple">
      <section data-analytics-section="marquee" className="kw-marquee" aria-labelledby="hero-title">
        <div className="kw-marquee-copy">
          <span className="kw-small-label">
            CUSTOM BUSINESS SOFTWARE & AI SOLUTIONS
          </span>
          <h1 id="hero-title">
            Your business.
            <br />
            <span>Less busywork.</span>
          </h1>
          <p>
            Your documents and processes, turned into custom software
            <br />
            and AI that give your team time back.
          </p>
          <Link
            to="/contact"
            className="kw-primary-link"
            data-analytics="hero_contact"
          >
            Let’s talk about your project <ArrowUpRight size={17} />
          </Link>
        </div>
        <OutcomeScene />
      </section>
      <OrganizationReferences />
      <BusinessExamples />
      <ProductSpotlights />
      <ProductReach />
      <ClientTestimonials />
      <DiscoverySection />
      <BrochureDownload placement="home" />
      <section data-analytics-section="founder-simple" className="kw-founder-simple">
        <Reveal className="kw-founder-simple-image">
          <span className="kw-founder-photo-label">
            YOUR PARTNER IN THE BUILD
          </span>
          <img
            src="/images/vasili-karalewich.jpeg"
            alt="Vasili Karalewich, founder"
            width="1284"
            height="1272"
            loading="lazy"
          />
          <div className="kw-founder-photo-caption">
            <strong>Vasili Karalewich</strong>
            <span>Founder · Karalewich</span>
          </div>
        </Reveal>
        <Reveal delay={120}>
          <span className="kw-small-label">MEET OUR FOUNDER</span>
          <h2>
            Engineering experience.
            <br />A direct partnership.
          </h2>
          <p>
            Founded by Vasili Karalewich, our practice brings software
            development experience dating to 2018. We understand your business,
            identify opportunities, and build for the long term.
          </p>
          <Link to="/about" data-analytics="meet_founder">
            Meet Vasili <ArrowUpRight size={16} />
          </Link>
          <Link
            to="/how-we-work"
            className="kw-founder-process"
            data-analytics="process_contact"
          >
            A conversation. A working version. A clear next step.
            <ArrowRight size={16} />
          </Link>
        </Reveal>
      </section>
      <LatestNews />
      <section data-analytics-section="simple-contact" className="kw-simple-contact">
        <Reveal>
          <span className="kw-small-label">LET’S MAKE WORK WORK BETTER</span>
          <h2>What’s getting in your way?</h2>
          <Link
            to="/contact"
            className="kw-primary-link"
            data-analytics="section_contact"
          >
            Tell us about it <ArrowUpRight size={17} />
          </Link>
        </Reveal>
      </section>
    </main>
  );
}
